import { colors } from 'components/styles/variables';
import { resolve } from 'styled-jsx/css';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import tapEvent, { FooterAction } from 'lib/Tracking/Footer/TapEvent';
import useEvents from 'lib/hooks/useEvents';
import { SourcePages } from 'lib/EventSchema';
import Link from './Link';

/* istanbul ignore next */
const aCss = resolve`
.view-all {
  color: ${colors.G2};
  font-size: 14px;
}`;

interface ItemProps {
  href: string;
  onClick: () => void;
  children: JSX.Element;
}

function Item({ href, onClick, children }: ItemProps): JSX.Element {
  return (
    <li>
      <Link href={href} onClick={onClick} className={`${aCss.className} view-all`}>
        {children}
        {` `}
        <span className="right-caret">^</span>
      </Link>
      <style jsx>
        {`
          .right-caret {
            display: inline-block;
            transform: rotate(90deg);
          }

          li {
            list-style: none;
            text-transform: uppercase;
          }
        `}
      </style>
      {aCss.styles}
    </li>
  );
}

export default function SeeAll(): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const { asPath } = useRouter();

  function logFooterTapEvent(action: FooterAction): void {
    logger.log(tapEvent({ action, pathName: asPath as SourcePages }));
  }

  return (
    <ul className="see-all-links" role="navigation">
      <Item
        href="/used-cars-city-state"
        onClick={(): void => {
          logFooterTapEvent('see_all_cities');
        }}
      >
        {t('footer.viewAllPopularCities')}
      </Item>
      <Item
        href="/used-models"
        onClick={(): void => {
          logFooterTapEvent('see_all_models');
        }}
      >
        {t('footer.viewAllPopularModels')}
      </Item>

      <Item
        href="/body+style-category"
        onClick={(): void => {
          logFooterTapEvent('see_all_categories');
        }}
      >
        {t('footer.viewAllPopularCategories')}
      </Item>
      <style jsx>
        {`
          ul {
            margin-left: 0;
            padding-left: 0;
          }
        `}
      </style>
    </ul>
  );
}
